import { HttpParams as AngularHttpParams } from '@angular/common/http';
import { Params } from '@angular/router';
import { SpreadRecursive } from '../../services/spread-recursive';

export class HttpParams {
    private readonly params: AngularHttpParams;

    getParams(): AngularHttpParams {
        return this.params;
    }

    toString(): string {
        return this.params.toString();
    }

    private filter(queryParams: Params): Params {
        let params = {};
        Object.keys(queryParams).forEach(p => {
            if (queryParams[p]) {
                const key = p + (Array.isArray(queryParams[p]) ? '[]' : '');
                params = {
                    ...params,
                    [key]: queryParams[p],
                };
            }
        });

        return params;
    }

    constructor(params: Params) {
        this.params = new AngularHttpParams({
            fromObject: SpreadRecursive.clone(this.filter(params)),
        });
    }
}
